import React from 'react'

const SeventhSection = () => {

    return (
        <div className='py-12 bg-blue-primary text-white'>

            <div className='mt-12 container mx-auto pb-12 space-y-4 md:space-y-8 text-xl lg:text-2xl'>
                <h1 data-aos="fade-right" className='text-left  font-bold text-3xl'>
                    ETICA DELL’AZIENDA
                </h1>
                <p data-aos="fade-right">
                    Il Papa Giovanni XXIII persegue da sempre l’eccellenza nei propri servizi e un rapporto sinergico con gli
                    ospiti. 
                </p>

                <div>
                    <h1 data-aos="fade-right" className='text-left  font-bold text-2xl'>Argomentazioni primarie:</h1>
                    <p data-aos="fade-right">- Informazioni, accessibilità, umanizzazione e relazioni con i clienti. </p>
                    <p data-aos="fade-right">- Assistenza sanitaria. </p>
                    <p data-aos="fade-right">- Comfort alberghiero. </p>
                </div>

                <div>
                    <h1 data-aos="fade-right" className='text-left  font-bold text-2xl'>Parametri prestazionali</h1>
                    <p data-aos="fade-right">Gli standard della struttura sono disponibili su richiesta. Il Riesame della Direzione ne riassume i principali
                    ed è esposto nel tabellone della qualità al piano terra. </p>
                </div>

                <div>
                    <h1 data-aos="fade-right" className='text-left  font-bold text-2xl'>Diritti del paziente</h1>
                    <p data-aos="fade-right">
                        Conoscere i propri diritti aiuta a comprendere i doveri. Ricevere cure e trattamenti di qualità richiede una
                        stretta collaborazione tra paziente e personale. Tutti i pazienti vengono informati sugli esiti degli esami e
                        sulle terapie praticate.
                    </p>
                </div>

                <p data-aos="fade-right">
                    Eventuali reclami o suggerimenti sui servizi possono essere presentati alla Direzione Sanitaria, situata al
                    piano terra. Per gli orari di ingresso, rivolgersi alla struttura.
                </p>

            </div>
        </div>

    )
}

export default SeventhSection